import React from 'react';
import PersonalWebsite from './PersonalWebsite';

function App() {
  return <PersonalWebsite />;
}

export default App;
